import React from "react";
import InputField from "../../../components/inputs/inputField";
import SelectField from "../../../components/inputs/selectField";
import ColorField from "../../../components/inputs/colorField";
import TextAreaField from "../../../components/inputs/textAreaField";

const iconSizeOptions = [
    {
        label: '72x72',
        value: '72x72'
    },
    {
        label: '96x96',
        value: '96x96'
    },
    {
        label: '128x128',
        value: '128x128'
    },
    {
        label: '144x144',
        value: '144x144'
    },
    {
        label: '152x152',
        value: '152x152'
    },
    {
        label: '192x192',
        value: '192x192'
    },
    {
        label: '384x384',
        value: '384x384'
    },
    {
        label: '512x512',
        value: '512x512'
    }
];

const iconTypeOptions = [{ label: 'image/png', value: 'image/png' }, { label: 'image/jpg', value: 'image/jpg' }];
class AppSetup extends React.Component {

    constructor(props) {
        super(props);
        const { event } = this.props;
        const { pwaDetails } = event;
        this.state = {
            pwaEnabled: event.pwaEnabled,
            name: pwaDetails.name,
            shortName: pwaDetails.shortName,
            description: pwaDetails.description,
            defaultPath: pwaDetails.defaultPath,
            backgroundColor: pwaDetails.backgroundColor,
            iosModalInstallationInstructions: pwaDetails.iosModalInstallationInstructions,
            promptTimeout: pwaDetails.promptTimeout,
            mobileIcon: pwaDetails.icons,
            isValid: true,
            iconsError: false,
            privatePathOptions: [],
            editedPwaDetails: {},
            editing: false
        };
    }

    savePwaDetails = () => {
        let pwaDetails = {
            name: this.state.name,
            shortName: this.state.shortName,
            description: this.state.description,
            defaultPath: this.state.defaultPath,
            backgroundColor: this.state.backgroundColor,
            iosModalInstallationInstructions: this.state.iosModalInstallationInstructions,
            promptTimeout: this.state.promptTimeout,
            icons: this.state.mobileIcon
        };
        this.props.savePwaDetails({ pwaDetails }, () => {
            this.setState({ editing: false });
        });
    }

    enablePWA = () => {
        const { pwaEnabled } = this.state;
        this.props.savePwaDetails({ pwaEnabled: !pwaEnabled }, () => {
            this.setState({ pwaEnabled: !pwaEnabled });
        });
    }

    render() {
        const {
            name,
            shortName,
            description,
            defaultPath,
            backgroundColor,
            iosModalInstallationInstructions,
            promptTimeout,
            mobileIcon,
            isValid,
            iconsError,
            privatePathOptions,
            editedPwaDetails,
            pwaEnabled
        } = this.state;
        const { editing, readOnly, requiredFields } = this.props;
        return (<div className="sectionBody">
            <div className="sectionBlock">
                <h2 className='blockHeader'>Enable Mobile App</h2>
                <button className={`prim `} onClick={this.enablePWA}>
                    {pwaEnabled ? 'Disable' : 'Enable'}
                </button>

                <h2 className='blockHeader'>Installation</h2>
                <InputField
                    label="Application Name"
                    value={name}
                    errorTrigger={requiredFields.name}
                    disabled={readOnly}
                    required={true}
                    onChange={(e) => {
                        this.setState({
                            editedPwaDetails: { ...editedPwaDetails, name: e.target.value },
                            name: e.target.value,
                            editing: true
                        });
                    }}
                />
                <InputField
                    label="Application Short Name"
                    value={shortName}
                    disabled={readOnly}
                    required={true}
                    errorTrigger={requiredFields.shortName}
                    onChange={(e) => {
                        this.setState({
                            editedPwaDetails: { ...editedPwaDetails, shortName: e.target.value },
                            shortName: e.target.value,
                            editing: true
                        });
                    }}
                />

                <InputField
                    label="Application Description"
                    value={description}
                    disabled={readOnly}
                    className={`editingField`}
                    onChange={(e) => {
                        this.setState({
                            editedPwaDetails: { ...editedPwaDetails, description: e.target.value },
                            description: e.target.value,
                            editing: true
                        });
                    }}
                />
                <SelectField
                    label="Default Home Page"
                    required={true}
                    value={
                        defaultPath ? (
                            defaultPath
                        ) : (
                            {
                                label: '',
                                value: ''
                            }
                        )
                    }
                    errorTrigger={requiredFields.defaultPath}
                    name="registrationPageSlug"
                    disabled={readOnly}
                    options={this.state.privatePathOptions}
                    onChange={(path) => {
                        this.setState({
                            editedPwaDetails: { ...editedPwaDetails, defaultPath: { label: path.label, value: path.value } },
                            defaultPath: { label: path.label, value: path.value },
                            editing: true
                        });
                    }}
                />
                <ColorField
                    label="Application Color"
                    value={backgroundColor}
                    type="color"
                    required={true}
                    errorTrigger={requiredFields.backgroundColor}
                    disabled={readOnly}
                    onChange={(e) => {
                        this.setState({
                            editedPwaDetails: { ...editedPwaDetails, backgroundColor: e },
                            backgroundColor: e,
                            editing: true
                        });
                    }}
                />
                <TextAreaField
                    label="Installation Prompt Message"
                    value={iosModalInstallationInstructions}
                    disabled={readOnly}
                    required={true}
                    errorTrigger={requiredFields.iosModalInstallationInstructions}
                    className={`editingField`}
                    onChange={(e) => {
                        this.setState({
                            iosModalInstallationInstructions: e.target.value,
                            editedPwaDetails: { ...editedPwaDetails, iosModalInstallationInstructions: e.target.value },
                            editing: true
                        });
                    }}
                />
                <InputField
                    label="If installation prompt is dismissed, show again after (hours)"
                    value={promptTimeout}
                    type="number"
                    disabled={readOnly}
                    required={true}
                    errorTrigger={requiredFields.promptTimeout}
                    className={`editingField`}
                    onChange={(e) => {
                        this.setState({
                            promptTimeout: e.target.value,
                            editedPwaDetails: { ...editedPwaDetails, promptTimeout: e.target.value },

                            editing: true
                        });
                    }}
                />

                <label className="displayLabel">
                    <div className="flex-ac">
                        Mobile Application Homescreen Icons *
                        <div
                            onClick={() => {
                                var exists = mobileIcon.find(
                                    (i) => i.src == '' || i.type == '' || i.size == ''
                                );
                                if (mobileIcon.length == 0 || !exists) {
                                    this.setState({
                                        mobileIcon: [...mobileIcon, { src: '', size: '', type: '' }]
                                    });
                                } else {
                                    this.setState({ isValid: false });
                                }
                            }}
                        >
                            <i className="las la-plus-circle ml-10 c-pointer clickable" />
                        </div>
                        {iconsError && (
                            <span style={{ marginLeft: 10, color: '#b90000' }}>Add at least one icon</span>
                        )}
                    </div>
                </label>

                {mobileIcon.map((icon, index) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div
                                onClick={() => {
                                    let updatedMobileIcon = mobileIcon.filter((i, newIndex) => {
                                        if (index !== newIndex) return i;
                                    });
                                    this.setState({ mobileIcon: updatedMobileIcon, editing: true });
                                }}
                            >
                                <i className="las la-minus-circle mr-10 c-pointer" style={{ color: 'red' }} />
                            </div>
                            <InputField
                                label="Icon Url"
                                value={icon.src}
                                onChange={(e) => {
                                    let mobileObj = JSON.parse(JSON.stringify(mobileIcon));
                                    mobileObj[index].src = e.target.value;
                                    this.setState({
                                        mobileIcon: mobileObj,
                                        editing: true
                                    });
                                }}
                            />
                            <SelectField
                                label="Icon Size"
                                value={
                                    icon.size ? (
                                        {
                                            label: icon.size,
                                            value: icon.size
                                        }
                                    ) : (
                                        {
                                            label: '',
                                            value: ''
                                        }
                                    )
                                }
                                name="registrationPageSlug"
                                options={iconSizeOptions}
                                disabled={readOnly}
                                onChange={(path) => {
                                    let mobileObj = JSON.parse(JSON.stringify(mobileIcon));
                                    mobileObj[index].size = path.label;
                                    this.setState({
                                        mobileIcon: mobileObj,
                                        editing: true
                                    });
                                }}
                            />
                            <SelectField
                                label="Icon Type"
                                value={
                                    icon.type ? (
                                        {
                                            label: icon.type,
                                            value: icon.type
                                        }
                                    ) : (
                                        {
                                            label: '',
                                            value: ''
                                        }
                                    )
                                }
                                name="registrationPageSlug"
                                options={iconTypeOptions}
                                disabled={readOnly}
                                onChange={(path) => {
                                    let mobileObj = JSON.parse(JSON.stringify(mobileIcon));
                                    mobileObj[index].type = path.label;
                                    this.setState({
                                        mobileIcon: mobileObj,
                                        editing: true
                                    });
                                }}
                            />
                        </div>
                    );
                })}
                {!isValid && <div style={{ color: 'red' }}>All Fields must be defined</div>}
            </div>
        </div>
        );
    }
}

export default AppSetup;